import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import DesignWorkflow from './components/DesignWorkflow'
import DeleteModal from 'Common/DeleteModal'

const WorkflowDesigner: React.FC = () => {
  const [isModalDeleteVisible, setIsModalDeleteVisible] = React.useState(false)
  const handleHideModal = () => setIsModalDeleteVisible(false)
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const isEditing = Boolean(id)

  document.title = isEditing ? 'Edit Workflow | EngageHub IQ' : 'Create Workflow | EngageHub IQ'

  const handleGoBack = () => {
    setIsModalDeleteVisible(!isModalDeleteVisible)
  }

  const handleDelete = () => {
    navigate('/workflow')
    handleHideModal()
  }

  return (
    <div className="h-[calc(100vh-70px)] flex flex-col">
      <div className="flex-shrink-0 p-6 pb-[12px] border-b border-slate-200 dark:border-zink-500">
        <div className="flex items-center gap-4">
          <button
            onClick={handleGoBack}
            className="p-2 rounded-md hover:bg-slate-100 dark:hover:bg-zink-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-15 font-bold dark:text-zink-50">
              {isEditing ? 'Edit Workflow' : 'Create Workflow'}
            </h1>
            <p className="text-slate-600 dark:text-zink-200">
              {isEditing ? 'Modify your workflow design' : 'Design and create a new automated workflow'}
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-hidden">
        <DesignWorkflow
          workflowId={id as string}
          isEditing={isEditing}
          onChangeAction={handleGoBack}
        />
      </div>

      <DeleteModal
        show={isModalDeleteVisible}
        onHide={handleHideModal}
        onDelete={handleDelete}
        title="You have unsaved changes"
        content="If you go back now, you will lose all unsaved changes. Are you sure you want to discard your changes and leave this page?"
        cancelText='Cancel'
        deleteText='Discard'
      />
    </div>
  )
}

export default WorkflowDesigner